/* eslint-disable import/prefer-default-export */
import { graphql, useStaticQuery } from 'gatsby'

export const useFooterData = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      allWpPage(
        filter: {
          pageType: { taxonomy: { eq: "content" } }
          filterargument: { filterargument: { eq: "footer" } }
        }
      ) {
        nodes {
          id
          slug
          status
          pageType {
            taxonomy
          }
          contenttypes {
            footer {
              sociallabel
              generallinkslabel
              addresslabel
              addresstext
              emailaddress
              emaillabel
              footermaincategories
              generallinks {
                generallink1 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                generallink2 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                generallink3 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                generallink4 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                generallink5 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
              }
              socialicon1 {
                iconurl
                icon {
                  node {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
              }
              socialicon2 {
                iconurl
                icon {
                  node {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
              }
              socialicon3 {
                iconurl
                icon {
                  node {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
              }
              socialicon4 {
                iconurl
                icon {
                  node {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
              }
              socialicon5 {
                iconurl
                icon {
                  node {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
              }
            }
          }
          language {
            slug
          }
        }
      }
    }
  `)
  return data.allWpPage.nodes
}
